import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { Input } from "sr/helpers";

type Props = {
  data: { budget?: string };
  HandleDataProps: (payload: { budget: string }) => void;
  externalErrorId?: string;
};

const RequirementBudgetChange = forwardRef(({ data, HandleDataProps, externalErrorId }: Props, ref) => {
  const [budget, setBudget] = useState<string>("");
  const [errorId, setErrorId] = useState<string>("");

  useEffect(() => {
    setBudget(data?.budget || "");
  }, [data?.budget]);

  useImperativeHandle(ref, () => ({
    validateData: () => {
      const raw = (budget ?? '').toString();
      if (!raw.trim()) {
        setErrorId('INPUT.VALIDATION.REQUIREMENT.BUDGET');
        return false;
      }
      const n = Number(raw.replace(/,/g, ''));
      if (!Number.isFinite(n)) {
        setErrorId('INPUT.VALIDATION.REQUIREMENT.BUDGET.NUMBER');
        return false;
      }
      if (n < 100) {
        setErrorId('INPUT.VALIDATION.REQUIREMENT.BUDGET.MIN');
        return false;
      }
      setErrorId("");
      return true;
    },
    submitForm: () => {
      const sanitized = budget.trim().replace(/[^0-9.]/g, '');
      const newData = { budget: sanitized };
      HandleDataProps(newData);
      return newData;
    },
  }));

  return (
    <div className="space-y-6">
      <Input
        name="budget"
        value={budget}
        onChange={(e: any) => {
          const raw = String(e.target.value || '')
          const sanitized = raw.replace(/[^0-9.]/g, '')
          const parts = sanitized.split('.')
          const intPart = parts[0] || ''
          const decPart = parts[1] !== undefined ? parts[1].slice(0, 2) : undefined
          const withCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          const formatted = decPart !== undefined ? `${withCommas}.${decPart}` : withCommas
          setBudget(formatted)
        }}
        placeholder="Budget"
        error={externalErrorId || errorId}
        type="text"
      />
    </div>
  );
});

export default RequirementBudgetChange;
